<template>
  <div>
    <buttonlist ref="SetBtn" @help="help"></buttonlist>
    <div style="margin-top: 5px">
      <tr>
        <td>{{ $t("getapi[12593]") }}</td>
        <td>
          <el-select v-model="type">
            <el-option :label="$t('getapi[1764]')" :value="1"></el-option>
            <el-option :label="$t('getapi[1763]')" :value="2"></el-option>
          </el-select>
        </td>
        <td>{{ $t("getapi[6055]") }}</td>
        <td>
          <el-input v-model="Query" type="text"></el-input>
        </td>
        <td>{{ $t("getapi[112]") }}</td>
        <td>
          <el-input v-model="PartCode" type="text"></el-input>
        </td>
        <el-button
          @click="search"
          size="mini"
          type="primary"
          style="margin-left: 5px"
          >{{ $t("getapi[1980]") }}</el-button
        >
      </tr>
    </div>

    <div style="display: flex">
      <div style="width:49%">
        <el-tag>{{ $t("getapi[12594]") }}</el-tag>
        <el-table
          :data="dataSet1"
          ref="singleTable"
          v-loading="loading"
          :highlight-current-row="true"
          border
          size="mini"
          :height="tableHeight"
          header-row-class-name="headerclass"
          row-key="uniquenumber"
          default-expand-all
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          style="width: 100%; margin-top:5px"
        >
          <el-table-column type="selection" v-if="false"></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="uniquenumber"
            label=""
            width="100"
          >
            <template slot-scope="scope">
              <i class="el-icon-tickets">{{ scope.row.ilevel }}</i>
            </template>
          </el-table-column>
          <!-- <el-table-column show-overflow-tooltip prop="ilevel" :label="$t('getapi[794]')"></el-table-column> -->

          <el-table-column
            show-overflow-tooltip
            prop="order_no"
            :label="$t('getapi[1889]')"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="original_order_no"
            :label="$t('getapi[2203]')"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="operation_name"
            :label="$t('getapi[2409]')"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="trans_time"
            :label="$t('getapi[2254]')"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="part_code"
            :label="$t('getapi[112]')"
          >
            <template slot-scope="scope">
              <span style="color:blue" @click="search1(scope.row)">{{
                scope.row.part_code
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="part_version"
            :label="$t('getapi[149]')"
          ></el-table-column>
          <el-table-column
            v-if="type == 1"
            show-overflow-tooltip
            prop="sequence_no"
            :label="$t('getapi[1764]')"
          ></el-table-column>
          <el-table-column
            v-if="type == 2"
            show-overflow-tooltip
            prop="batch_no"
            :label="$t('getapi[1763]')"
          ></el-table-column>
        </el-table>
      </div>
      <div style="width:49%">
        <el-tag>{{ $t("getapi[12595]") }}</el-tag>
        <el-table
          v-loading="loading"
          :data="dataSet2"
          ref="singleTable2"
          :highlight-current-row="true"
          :row-class-name="tableRowClassName"
          border
          size="mini"
          :height="tableHeight"
          header-row-class-name="headerclass"
          row-key="uniquenumber"
          default-expand-all
          lazy
          :load=load
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          style="width: 100%; margin-top:5px"
        >
          <el-table-column type="selection"></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="uniquenumber"
            label=""
            width="100"
          >
            <template slot-scope="scope">
              <i class="el-icon-tickets">{{ scope.row.ilevel }}</i>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="order_no"
            :label="$t('getapi[1889]')"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="original_order_no"
            :label="$t('getapi[2203]')"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="operation_name"
            :label="$t('getapi[2409]')"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="trans_time"
            :label="$t('getapi[2254]')"
          ></el-table-column>

          <el-table-column
            show-overflow-tooltip
            prop="part_code"
            :label="$t('getapi[112]')"
          >
            <template slot-scope="scope">
              <span style="color:blue" @click="search1(scope.row)">{{
                scope.row.part_code
              }}</span>
            </template>
          </el-table-column>

          <el-table-column
            show-overflow-tooltip
            prop="part_version"
            :label="$t('getapi[149]')"
          ></el-table-column>
          <el-table-column
            v-if="type == 1"
            show-overflow-tooltip
            prop="sequence_no"
            :label="$t('getapi[1764]')"
          ></el-table-column>
          <el-table-column
            v-if="type == 2"
            show-overflow-tooltip
            prop="batch_no"
            :label="$t('getapi[1763]')"
          ></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import Common from "@/components/Common";
import Array from "@/components/Array";
export default {
  name: "Traceability",
  data() {
    return {
      type: 1, //溯源类型
      Query: "", //检索条件
      PartCode: "", //物料编码
      tableHeight: Common.tableHeight2,
      dataSet1: [],
      dataSet2: [],
      loading: false,
        scrollTop:0,
        scrollTop2:0,
    };
  },
  mounted: function() {
    let that = this;
    that.userData = sessionStorage.getItem("userData");
    that.authority();
  },
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
            that.$refs.singleTable2.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop2 = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                this.$refs.singleTable2.bodyWrapper.scrollTop =this.scrollTop2;
            }, 13)
        })
    },
  methods: {
      help(){
          this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[12592]"),this.$t("getapi[15]"));
      },
    authority() {
      let that = this;
        if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
            that.$refs.SetBtn.SetOneBtnEnable('help',true);
        }
      that.$refs.SetBtn.SetButtonEnable("");
      that.type = 2;
    },
    search() {
      let that = this;
      let parm = {
        Type: that.type,
        Query: that.Query,
        PartCode: that.PartCode,
        LangType: that.$processdata.getLang(),
      };
      that.loading = true;
      that.$http.urlpost("/Inv/Manager/GetPartFromBy", parm, function(res) {
        if (res.Success == 1) {
          that.dataSet1 = res.DataContent.ListSource;
          that.dataSet2 = res.DataContent.ListEnd;
          that.getSearchNode().filter(that.dataSet2)
        }
        that.loading = false;
      });
    },
    search1(row) {
      let that = this;
      let parm = {};
      if (that.type == 1 && row.sequence_no != "*") {
        that.Query = row.sequence_no;
      }
      if (that.type == 2 && row.batch_no != "*") {
        that.Query = row.batch_no;
      }
      that.PartCode = row.part_code;

      if (that.type == 1) {
        parm = {
          Type: that.type,
          Query: row.sequence_no,
          PartCode: row.part_code,
          LangType: that.$processdata.getLang(),
        };
      } else {
        parm = {
          Type: that.type,
          Query: row.batch_no,
          PartCode: row.part_code,
          LangType: that.$processdata.getLang(),
        };
      }
      that.loading = true;
      that.$http.urlpost("/Inv/Manager/GetPartFromBy", parm, function(res) {
        if (res.Success == 1) {
          that.dataSet1 = res.DataContent.ListSource;
          that.dataSet2 = res.DataContent.ListEnd;
          that.getSearchNode().filter(that.dataSet2)
          
        }
        that.loading = false;
      });
    },
    getSearchNode:function(){
      let that = this
      let recursiveArray = function(arr){
          if(arr.color==1){
            arr.hasChildren = true;
            arr.children = []
          }
          if(arr.children != null && arr.children.length != 0){
              for (let array of arr.children){
                  recursiveArray(array)
              }
          }
      }
      return{
          filter:function(data){
              if(data.length == 0){
                  return
              }
              for (let rootMenu of data) {
                  recursiveArray(rootMenu)
              }
              return that.dataSet2
          }
      }
  },
    // 获取子数据
    getSonView(row) {
      let that = this;
      if (row.hasChildren == false) {
        return;
      }
      let parm = {
        ilevel: row.ilevel,
        parentuniquenumber: row.parentuniquenumber,
        uniquenumber: row.uniquenumber,
        order_no: row.order_no,
        original_order_no: row.original_order_no,
        operation_code: row.operation_code,
        operation_name: row.operation_name,
        part_code: row.part_code,
        part_version: row.part_version,
        sequence_no: row.sequence_no,
        batch_no: row.batch_no,
        qty: row.qty,
        trans_time: row.trans_time,
        color: row.color,
      };
      that.token = JSON.parse(that.userData).token;
      $.ajax({
        url:
          Common.Url +
          "/Inv/Manager/GetPartFromSubsetByParent?token=" +
          that.token,
        type: "post",
        async: false,
        data: JSON.stringify(parm),
        contentType: "application/json",
        success: function(res) {
          if (res.Success == 1) {
            let data1 = res.DataContent.List;
            if (data1.length != 0) {
              for (let i = 0; i < data1.length; i++) {
                data1[i].hasChildren = true;
              }
              row.children = data1;
            } else {
              row.hasChildren = true;
              row.children = [];
            }
          }
        },
        error: function(xhr, errorType, error) {},
      });
    },
    load(row, treeNode, resolve) {
      let that = this;
      console.log('执行' + JSON.stringify(row))
      that.getSonView(row);      
      setTimeout(() => {
        resolve(row.children);
      }, 1000);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.color == 1) {
        return "red";
      }
    },
  },
};
</script>

<style scoped lang="less">
span.label-fade-enter {
  font-size: medium;
  margin-right: 20px;
}
/deep/.blue {
  color: blue;
}
/deep/.red {
  color: red;
}
table {
  border-collapse: separate;
  border-spacing: 0px 5px;
  td {
    padding-left: 3px;
    white-space: pre;
  }
}
</style>
